/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./widgetChartDataOptionsEditor.vue?vue&type=template&id=2242a12d"
import script from "./widgetChartDataOptionsEditor.vue?vue&type=script&lang=js"
export * from "./widgetChartDataOptionsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports